<template>
  <v-row>

    <v-col cols="12"> 
      <v-sheet 
        outlined
        >
        <v-row class="pa-4">

          <v-col
            class="d-flex"
            cols="12"
          >
            <v-select
              :loading="loading"
              :items="editions"
              label="Edición"
              v-model="edition_id"
              name="editions"
              :item-text="'name'"
              :item-value="'id'"
              outlined
              @change="handleSelectChange"
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" v-if="!$vuetify.breakpoint.xs">
            <v-tabs
              fixed-tabs
              v-model="tabs"
              class="tab-gallery"
              :background-color="color_tab"
              dark
              height="70px"
            >
              <v-tab @click="handleTabChange(0)">
                <v-icon class="mr-6">mdi-lightbulb-on-outline</v-icon>
                Ideas Proyecto
              </v-tab>

              <v-tab @click="handleTabChange(1)">
                <v-icon>mdi-town-hall</v-icon>
                Ideas Proyecto(escuelas secundarias)
              </v-tab>
              
              <v-tab @click="handleTabChange(2)">
                <v-icon class="mr-6">mdi-account-cash</v-icon>
                Modelos de Negocio
              </v-tab>
            </v-tabs>
          </v-col>

          <v-col cols="12" v-if="$vuetify.breakpoint.xs">
            <v-tabs
              fixed-tabs
              v-model="tabs"
              class="tab-gallery"
              :background-color="color_tab"
              dark
              height="70px"
            >
              <v-tab @click="handleTabChange(0)">
                <v-icon class="mr-6">mdi-lightbulb-on-outline</v-icon>
              </v-tab>
              <v-tab @click="handleTabChange(1)">
                <v-icon>mdi-town-hall</v-icon>
              </v-tab>
              <v-tab @click="handleTabChange(2)">
                <v-icon class="mr-6">mdi-account-cash</v-icon>
              </v-tab>
            </v-tabs>

            <h4 v-if="type_postulation===0" class="pt-4" align="center">
              Ideas Proyectos
            </h4>
            <h4 v-if="type_postulation===1" class="pt-4" align="center">
              Ideas Proyectos (escuelas secundarias)
            </h4>
            <h4 v-if="type_postulation===2" class="pt-4" align="center">
              Modelos de Negocio
            </h4>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="find"
              label="Buscar"
              outlined
              clearable
              background-color="white"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="3" md="3" sm="12" v-for="(entrepreneurship) in entrepreneurshipsFiltered" :key="entrepreneurship.id">
            <cardProjectGallery :data="entrepreneurship"/>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL
  import axios from 'axios'
  import cardProjectGallery from '@/components/card/cardProyectGalleryOrganizer.vue'

  export default {
    name: 'EntrepreneurshipsWindowsOrganizer',
    components:{cardProjectGallery},
    data: () => ({
      find:'',
      editions: [],
      edition_id: null,
      type_postulation: null,
      tabs: 0,
      entrepreneurships:[],
      loading:false,
      isLiked: false
    }),
    computed: {
      buttonColor() {
        return this.isLiked ? "red" : "grey lighten-1";
      }, 
      type_postulationWatcher() {
        return this.type_postulation;
      },
      color_tab () {
        switch (this.tabs) {
          case 0: return '#00A1B8'
          case 1: return '#11778C'
          case 2: return '#23495C'
          default: return '#00A1B8'
        }
      }, 

      entrepreneurshipsFiltered(){
        return this.entrepreneurships.filter((entrepreneurship) => {
          if(this.find!=null){
            return entrepreneurship.title.toLowerCase().includes(this.find.toLowerCase());
          }else{
            return this.entrepreneurships
          }
        });
      }
    },
    watch: {
      edition_id: {
        handler: function() {
            this.getEntrepreneurshipsWindowsOrganizer(); // call it in the context of your component object
        },
        deep: true
      },

      // Watcher para type_postulationWatcher
      type_postulationWatcher(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loading=true
          this.getEntrepreneurshipsWindowsOrganizer(); // Llama a la función getEntrepreneurship cuando cambie type_postulation
        }
      }
    },
    methods:{
      async getEditions()
      {
        let that = this
        this.loading=true
        await axios.get('organizer/editions').then(response =>{
          this.editions = response.data.data.editions
          
          if(this.editions && !this.edition_id){
            that.edition_id = this.editions[0].id
          }
          this.loading=false
        }).catch(error => {
          console.log(error);
          this.loading=false
        })
      },

      async getEntrepreneurshipsWindowsOrganizer(){
        if(this.edition_id){
          this.loading=true
          let tp = this.type_postulation + 1
          await axios.get('organizer/edition/'+this.edition_id+'/windows/'+tp).then(response =>{
            this.entrepreneurships = response.data.data.windows

            this.entrepreneurships.forEach(element => {
              if(element.logo){
                element.url_logo = APP_URL + element.logo
              }else{
                element.url_logo = APP_URL+'/img/image_available.png'
              }
            });
            this.loading = false
          }).catch(error => {
            console.log(error);
          })
        }
      },

      createdView()
      {
        this.type_postulation = this.$store.state.currentTypeTab
        this.tabs = this.type_postulation
        this.edition_id = this.$store.state.currentEdition
      },

      handleTabChange(tab)
      {
        this.$store.state.currentTypeTab = tab
        this.type_postulation = tab
      },

      handleSelectChange(edition_id)
      {
        this.getEntrepreneurshipsWindowsOrganizer()
        this.$store.state.currentEdition = edition_id
      },

      showEntrepreneurships(slug){
        this.$router.push({ name: 'showBusinessModelsWindows', params: { slug: slug } })
      }
    },
    created(){
      Promise.all([
        this.createdView(),
        this.getEditions()
      ]).then(() => {
        this.getEntrepreneurshipsWindowsOrganizer()
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.tab-gallery {
  border-radius: 6px!important;
  background-color: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}
</style>
